import { FormattedMessage } from 'react-intl';
import { cn } from '@/helpers/classnames';

interface Props {
  className?: string;
}

export const FavoredBadge = ({ className }: Props) => (
  <span
    className={cn(
      'h-min whitespace-nowrap rounded bg-primary-400 px-1.5 py-0.5 font-medium text-contrast-primary',
      className,
    )}
  >
    <FormattedMessage defaultMessage="Föredragen" />
  </span>
);
